import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import useClients from '../hooks/useClients';
import ClientTable from './ClientTable';
import SearchBar from './SearchBar';
import AdminHeader from './AdminHeader';
import './ClientManagement.css';

const ClientManagement = ({ onBack }) => {
  const { token } = useAuth();
  const clientsHook = useClients(token);

  return (
    <div className="admin-dashboard">
      <AdminHeader 
        title="Gestão de Clientes" 
        onBack={onBack}
        showBackButton={true}
      />

      <main className="dashboard-main">
        <div className="breadcrumb">
          <span className="breadcrumb-item" onClick={onBack}>Painel Administrativo</span>
          <span className="breadcrumb-separator">›</span>
          <span className="breadcrumb-item active">Gestão de Clientes</span>
        </div>

        <div className="dashboard-content">
          <div className="management-header">
            <div className="header-info">
              <h2>Clientes Cadastrados</h2>
              <p>Gerencie informações dos clientes, dados de contato e endereços</p>
            </div>
            
            <div className="header-stats">
              <div className="stat-card">
                <div className="stat-number">{clientsHook.clients.length}</div>
                <div className="stat-label">Total de Clientes</div>
              </div>
            </div>
          </div>

          <div className="search-section">
            <SearchBar 
              searchTerm={clientsHook.searchTerm}
              setSearchTerm={clientsHook.setSearchTerm}
              hasChanges={clientsHook.hasChanges || false}
              saveChanges={clientsHook.saveChanges || (() => {})}
              undoChanges={clientsHook.undoChanges || (() => {})}
              updating={clientsHook.updating}
              tableLocked={clientsHook.tableLocked}
              editedData={clientsHook.editedData || []}
              error={clientsHook.error}
              products={clientsHook.clients}
              refreshFromServer={clientsHook.refreshClients}
              loading={clientsHook.loading}
            />
          </div>

          <div className="table-section">
            {clientsHook.loading ? (
              <div className="loading-overlay">
                <div className="spinner"></div>
                <p>Carregando clientes...</p>
              </div>
            ) : (
              <ClientTable 
                clients={clientsHook.clients || []}
                updateClient={clientsHook.updateClient}
                revertClient={clientsHook.revertClient}
                handleSort={clientsHook.handleSort}
                getSortIndicator={clientsHook.getSortIndicator}
                isLowStock={clientsHook.isLowStock}
                formatPrice={clientsHook.formatPrice}
                updating={clientsHook.updating}
                tableLocked={clientsHook.tableLocked}
                clearEditingState={clientsHook.clearEditingState}
              />
            )}
          </div>

          {clientsHook.error && (
            <div className="error-banner">
              <div className="error-content">
                <span className="error-icon">⚠️</span>
                <span className="error-message">{clientsHook.error}</span>
                <button 
                  onClick={clientsHook.refreshClients}
                  className="error-retry-button"
                >
                  Tentar Novamente
                </button>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default ClientManagement;
